export const loadClient = async (clientName: string) => {
  if (clientName === 'AuthClient') {
    const { default: AuthClient } = await import(
      // eslint-disable-next-line import/no-unresolved
      /* webpackChunkName: "AuthClient" */ '@skyscanner/auth-client'
    );
    return AuthClient;
  }
  // Ensure consistent return value or throw an error if clientName doesn't match
  throw new Error(`Unknown client name: ${clientName}`);
};
